module.exports = __webpack_public_path__ + "8462915a111946a97e8abcfbccd5d8de.pdf";